import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa";
import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { name: "Facebook", icon: FaFacebookF, url: "https://www.facebook.com/" },
    { name: "Instagram", icon: FaInstagram, url: "https://www.instagram.com/hirecura/" },
    { name: "LinkedIn", icon: FaLinkedinIn, url: "https://www.linkedin.com/company/hirecura/" },
    { name: "YouTube", icon: FaYoutube, url: "https://www.youtube.com/" },
  ];

  const navigationLinks = [
    { label: "Find Jobs", to: "/find-jobs" },
    { label: "For Employers", to: "/for-employers" },
    { label: "How It Works", to: "/how-it-works" },
    { label: "About Us", to: "/about-us" },
    { label: "Contact Us", to: "/contact-us" },
  ];

  return (
    <footer className="mt-10 border-t border-slate-200 bg-slate-50 px-5 text-center md:mt-16 md:bg-white md:px-6">
      <div className="mx-auto flex max-w-5xl flex-col items-center py-7 md:py-10">
        {/* Brand */}
        <Link
          to="/"
         onClick={() => window.scrollTo({ top: 0, left: 0, behavior: "instant" })}
          aria-label="HireCura Home"
          className="text-[28px] font-bold leading-none tracking-tight md:text-4xl"
        >
          <span className="text-[#0F172A]">Hire</span>
          <span className="text-[#0D9488]">Cura</span>
        </Link>

        <p className="mt-2 text-sm leading-5 text-slate-500 md:mt-3 md:text-base md:leading-7">
          Where Careers Meet Care.
        </p>

        {/* Social links */}
        <div className="mt-4 flex items-center justify-center gap-3 md:mt-5 md:gap-4">
          {socialLinks.map(({ name, icon: Icon, url }) => (
            <a
              key={name}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={name}
              className="flex h-9 w-9 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-700 transition-colors duration-200 hover:border-[#0D9488] hover:bg-[#0D9488] hover:text-white md:h-10 md:w-10"
            >
              <Icon size={17} />
            </a>
          ))}
        </div>

        {/* Navigation: simple and uncluttered on mobile */}
        <nav
          aria-label="Footer navigation"
          className="mt-5 grid w-full max-w-[330px] grid-cols-2 gap-x-5 gap-y-3 text-sm md:mt-7 md:flex md:max-w-none md:flex-wrap md:items-center md:justify-center md:gap-x-3 md:gap-y-3 md:text-base"
        >
          {navigationLinks.map((link, index) => (
            <span
              key={link.to}
              className={`flex items-center justify-center ${
                index === navigationLinks.length - 1 ? "col-span-2 md:col-span-1" : ""
              }`}
            >
              {index > 0 && (
                <span aria-hidden="true" className="hidden px-3 text-slate-300 md:inline">
                  |
                </span>
              )}
             <Link
                to={link.to}
                onClick={() => {
                  window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: "instant"
                  });
                }}
                className="py-1 font-medium text-slate-600 transition-colors hover:text-[#0D9488] md:font-normal"
              >
                {link.label}
              </Link>
            </span>
          ))}
        </nav>

        {/* Legal links */}
        <div className="mt-4 flex flex-wrap items-center justify-center gap-x-3 text-xs text-slate-500 md:mt-4 md:gap-x-3 md:text-sm">
          <Link to="/privacy-policy" className="transition-colors hover:text-[#0D9488]">
            Privacy Policy
          </Link>
          <span aria-hidden="true" className="text-slate-300">|</span>
          <Link to="/terms-and-conditions" className="transition-colors hover:text-[#0D9488]">
            Terms &amp; Conditions
          </Link>
        </div>

        {/* Copyright */}
        <div className="mt-5 w-full border-t border-slate-200 pt-4 md:mt-8 md:pt-6">
          <p className="mx-auto max-w-[300px] text-xs leading-5 text-slate-500 md:max-w-none md:text-sm">
            © {currentYear} HireCura Technologies Private Limited. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
